/* eslint-disable no-nested-ternary */
import React from 'react';
import * as S from './styled';
import { svg } from '../../../lib/svgList';

export default function Check({
	isChecked = false,
	isError = false,
	defaultCheckColor = true,
	setIsChecked = () => {},
	id = Math.random() * 1000,
	onClick = () => {},
	text,
	widthCheck = '18px',
	inputType = 'checkbox',
	disabled = false
}) {
	return (
		<S.Container onClick={onClick}>
			<S.ContainerCheck
				onClick={() => !disabled && setIsChecked(!isChecked)}
				isError={isError}
				widthCheck={widthCheck}
				defaultCheckColor={defaultCheckColor}
				inputType={inputType}
				isChecked={isChecked}
				disabled={disabled}
			>
				<input type={inputType} id={id} disabled={disabled} />
				{/* Span que receberá background e borda */}
				<span />
				{/* Ícone de check */}
				{isChecked && !disabled && <img src={svg.icon.check} alt="check" />}
			</S.ContainerCheck>

			{text && (
				<S.Box>
					<span>
						{text}
						{!isChecked && isError && <span className="error-send">Campo obrigatório</span>}
					</span>
				</S.Box>
			)}
		</S.Container>
	);
}
